import React, { useState } from "react";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import SearchIcon from "../../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";
import CustomHeaderBox from "../../../../../components/Universal/CustomHeaderBox.component";
import SalaryForm from "../../../../../components/PagesComponents/Financial/CashOutFlow/AcademicEx/Salaries/SalaryForm.component";
import ScrollableModal from "../../../../../components/Universal/ScrollableModal.component";
import SalarySlip from "../../../../../components/PagesComponents/Financial/CashOutFlow/AcademicEx/Salaries/SalarySlip.component";
import "../../../../../styles/Pages/Financial/CashOutFlow/AcademicEx/Salaries/Salaries.style.css";
import DatePicker from "../../../../../components/Universal/DatePicker.component";
import AllSalaryOutFlowTable from "../../../../../components/PagesComponents/Financial/CashOutFlow/AcademicEx/Salaries/AllSalaryOutFlowTable.component";
import HistoryTable from "../../../../../components/PagesComponents/Financial/CashOutFlow/AcademicEx/Salaries/HistoryTable.component";
import HistoryCustomHeaderBox from "../../../../../components/PagesComponents/Financial/CashOutFlow/AcademicEx/Salaries/HistoryCustomHeaderBox";

const Body = ({ salarySlipData, salaryTableData, historyTableData }) => {
  const modes = ["default", "outflow", "history"];
  const [mode, setMode] = useState("default");
  const [showSalarySlip, setShowSalarySlip] = useState(false);
  const showHistory = () => {
    setMode(modes[2]);
  };
  if (!modes.includes(mode)) {
    return <h2>Something went wrong</h2>;
  }

  if (mode === modes[0])
    return (
      <section className="salariesContainer">
        <Helmet>
          <title>Salaries</title>
          <meta
            name="description"
            content="Monitor and analyze cash inflow trends and contributions."
          />
          <meta
            name="keywords"
            content="salaries,cash outflow, financial dashboard, cash flow analysis, business finance"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
        <PageHeader title={"Salaries"} />
        <div className="salariesBodySection">
          <div className="distributeSalries">
            <h3>Distribute salareis</h3>
            <div className="input-box">
              <div className="searchInputContainer">
                <input
                  type="text"
                  className="pageHeaderInput"
                  placeholder="Search id"
                />
                <button className="searchBtn">
                  <img src={SearchIcon} alt="searchBtn" />
                </button>
              </div>
              <button
                onClick={() => setMode(modes[1])}
                className="blueActionBtnLight"
              >
                Only Salary Outflow
              </button>
            </div>
            {<CustomHeaderBox action={showHistory} />}
            {<SalaryForm onDispatch={setShowSalarySlip} />}
            <ScrollableModal
              isOpen={showSalarySlip}
              onClose={() => {
                setShowSalarySlip(false);
              }}
            >
              <SalarySlip salarySlipData={salarySlipData} />
            </ScrollableModal>
          </div>
        </div>
      </section>
    );

  if (mode === modes[1])
    return (
      <section className="salariesContainer">
        <Helmet>
          <title>Salaries</title>
          <meta
            name="description"
            content="Monitor and analyze cash inflow trends and contributions."
          />
          <meta
            name="keywords"
            content="salaries,cash outflow, financial dashboard, cash flow analysis, business finance"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
        <PageHeader title={"Only Salaries Outflow"} />
        <div className="salariesBodySection">
          <div className="distributeSalries">
            <h3>All Salary Outflow</h3>
            <div className="input-box">
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
              >
                <div className="searchInputContainer">
                  <input
                    type="text"
                    className="pageHeaderInput"
                    placeholder="Search id"
                  />
                  <button className="searchBtn">
                    <img src={SearchIcon} alt="searchBtn" />
                  </button>
                </div>
                <DatePicker
                  label=""
                  name="firstTimePaymentDate"
                  // setFieldValue={(val) => setFieldValue("date", val)}
                  placeholder={"Choose Date"}
                  // errors={errors}
                />
              </div>
              <div style={{ display: "flex", gap: "1rem" }} className="buttons">
                <button
                  style={{
                    backgroundColor: "var(--blueColor1)",
                    borderColor: "var(--blueColor1)",
                  }}
                  onClick={() => setMode(modes[0])}
                  className="actionBtn"
                >
                  Go to salary Section
                </button>
                <button className="actionBtn2">Download</button>
              </div>
            </div>
            <AllSalaryOutFlowTable tableData={salaryTableData} />
            <ScrollableModal
              isOpen={showSalarySlip}
              onClose={() => {
                setShowSalarySlip(false);
              }}
            >
              <SalarySlip salarySlipData={salarySlipData} />
            </ScrollableModal>
          </div>
        </div>
      </section>
    );

  if (mode === modes[2])
    return (
      <section className="salariesContainer">
        <Helmet>
          <title>Salaries</title>
          <meta
            name="description"
            content="Monitor and analyze cash inflow trends and contributions."
          />
          <meta
            name="keywords"
            content="salaries,cash outflow, financial dashboard, cash flow analysis, business finance"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
        <PageHeader title={"Salaries"} />
        <div className="salariesBodySection">
          <div className="distributeSalries">
            <h3>See All Salary Receipt</h3>
            <div className="input-box">
              <div className="searchInputContainer">
                <input
                  type="text"
                  className="pageHeaderInput"
                  placeholder="Search id"
                />
                <button className="searchBtn">
                  <img src={SearchIcon} alt="searchBtn" />
                </button>
              </div>
              <div style={{ display: "flex", gap: "1rem" }} className="buttons">
                <button
                  onClick={() => setMode(modes[0])}
                  style={{
                    backgroundColor: "var(--blueColor1)",
                    borderColor: "var(--blueColor1)",
                  }}
                  className="actionBtn"
                >
                  Go to salary section
                </button>
                <button
                  onClick={() => setMode(modes[1])}
                  className="blueActionBtnLight"
                >
                  Only salary outflow
                </button>
              </div>
            </div>
            <HistoryCustomHeaderBox />
            <HistoryTable tableData={historyTableData} />
            <ScrollableModal
              isOpen={showSalarySlip}
              onClose={() => {
                setShowSalarySlip(false);
              }}
            >
              <SalarySlip salarySlipData={salarySlipData} />
            </ScrollableModal>
          </div>
        </div>
      </section>
    );
};

export default Body;
